import { useEffect } from 'react';
import { Button, Card, Container } from 'react-bootstrap';
import { Link, useRouteError } from 'react-router-dom';
import { reportClientError, serializeError } from '../utils/errorLogger';

const RouteErrorBoundary = () => {
  const routeError = useRouteError();

  useEffect(() => {
    const parsed = serializeError(routeError);
    reportClientError({
      ...parsed,
      metadata: {
        kind: 'route-error-boundary',
      },
      errorDetails: routeError,
    });
  }, [routeError]);

  const parsed = serializeError(routeError);

  return (
    <Container className="py-5">
      <Card className="modern-card">
        <Card.Body className="p-4">
          <h1 className="text-primary mb-3">Something went wrong</h1>
          <p className="text-secondary">
            We logged this error so it can be investigated. You can head back home or try the previous action again.
          </p>
          <pre className="small text-danger bg-light p-3 rounded">{parsed.message}</pre>
          <div className="d-flex gap-2 mt-3">
            <Link to="/" className="btn btn-primary-modern">Back Home</Link>
            <Button variant="outline-secondary" onClick={() => window.location.reload()}>Reload</Button>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default RouteErrorBoundary;
